<div class="history-tl-container">
  <ul class="tl">
    <li *ngFor="let historial of historiales; let i = index" class="tl-item" ng-repeat="item in retailer_history">
      <div class="timestamp">
        {{historial.created_at | date:'d'}} de {{historial.created_at | date:'MMMM'}} del {{historial.created_at | date:'y'}}
        <br>{{historial.created_at | date:'h:mm a'}}
      </div>
      <div class="item-title"><b>{{historial.nombre_estado_externo ? historial.nombre_estado_externo : '--'}}</b></div>
      <div class="item-detail"> ha cambiado el estado de la solicitud a: {{historial.nombre_estado_externo ? historial.nombre_estado_externo : '--'  }}
      </div>
    </li>
  </ul>
</div>
